export default function PromotedSearchResults({searchTerm, searchResults, total = null, limit}) {
  return (
    <>
      <ul className="search-results__list">
      {
        searchResults.length > 0 && searchResults.slice(0, limit).map((result, index) =>
          <li className={"search-result search-result--promoted"}>
            <a href={result.url} key={result.url || index} className={"button button--tertiary search-result--promoted promoted-search"}>
              {result.title}
            </a>
          </li>
        )
      }
      </ul>
    </>
  );
}
